
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1okex_97",
  "button": "awsui_button_vjswe_1okex_101",
  "variant-normal": "awsui_variant-normal_vjswe_1okex_130",
  "is-activated": "awsui_is-activated_vjswe_1okex_143",
  "variant-icon": "awsui_variant-icon_vjswe_1okex_170",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1okex_170",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1okex_170",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1okex_188",
  "disabled": "awsui_disabled_vjswe_1okex_206",
  "variant-primary": "awsui_variant-primary_vjswe_1okex_214",
  "variant-link": "awsui_variant-link_vjswe_1okex_298",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1okex_550",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1okex_806",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1okex_895",
  "button-no-text": "awsui_button-no-text_vjswe_1okex_979",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1okex_983",
  "full-width": "awsui_full-width_vjswe_1okex_986",
  "icon-left": "awsui_icon-left_vjswe_1okex_1005",
  "icon-right": "awsui_icon-right_vjswe_1okex_1010",
  "icon": "awsui_icon_vjswe_1okex_1005"
};
  